import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useIsBrazil } from "@crehana/i18n";
import { useMediaQuery } from "@crehana/react-hooks";
import useAcademiesQuery from "./hooks/useAcademiesQuery";
import { useMainMenuContext } from "../../hooks";
import LeftMenuDesktop from "./layout/LeftMenuDesktop";
import LeftMenuMobile from "./layout/LeftMenuMobile";
import { jsx as _jsx } from "react/jsx-runtime";
var LeftMenu = function LeftMenu() {
  var _useMainMenuContext = useMainMenuContext(),
    variant = _useMainMenuContext.variant,
    loadingMe = _useMainMenuContext.loadingMe,
    me = _useMainMenuContext.me,
    layoutConfig = _useMainMenuContext.layoutConfig,
    onLeftMenuOpen = _useMainMenuContext.onLeftMenuOpen;
  var isBrazil = useIsBrazil();
  var _useAcademiesQuery = useAcademiesQuery(),
    buckets = _useAcademiesQuery.buckets;
  var _useMediaQuery = useMediaQuery('sm'),
    isSm = _useMediaQuery.matches;
  var shouldRenderCategories = !layoutConfig.hideCategories;
  var shouldRenderSolutionsMenu = !layoutConfig.hideSolutionsMenu;
  var shouldRenderNewCourses = !layoutConfig.hideNewCourses;
  var shouldRenderAcademies = !layoutConfig.hideAcademies && !!buckets.length;
  var shouldRenderMicroDegrees = !layoutConfig.hideMicroDegrees && !isBrazil;
  var shouldRenderResourcesButton = !layoutConfig.hideResourcesDropdown;
  var shouldRenderAdminDashboardLink = me.isB2BAdmin && !layoutConfig.hideB2BAdminDashboardLink;
  var shouldRenderPremiumLandingLink = (me.isAnonymous || me.isPAYG) && !layoutConfig.hidePremiumLandingLink;
  var shouldRenderB2BLandingLink = !loadingMe && !me.isB2B && !layoutConfig.hideB2BLandingLink;
  var shouldRenderInboxLink = me.hasInboxAccess && !layoutConfig.hideInboxLink && !me.isPremium || me.isMentor && !layoutConfig.hideInboxLink;
  var shouldRenderShoppingCartLink = (me.isAnonymous || me.isPAYG) && !layoutConfig.hideShoppingCart;
  var shouldHelpCenterLink = !layoutConfig.hideHelpCenterLink;
  var shouldRenderRegisterButton = me.isAnonymous && !layoutConfig.hideRegisterButton;
  var shouldRenderLoginButton = me.isAnonymous && !layoutConfig.hideLoginButton;
  var shouldRenderAppLinks = !layoutConfig.hideAppLinks;
  var shouldRenderHigherEdLink = !layoutConfig.hideHigherEdLink;
  var getShouldRenderCatalogMenu = function getShouldRenderCatalogMenu() {
    // This one forces to do not render catalog dropdown at all
    if (layoutConfig.hideCatalogDropdown) return false;

    // Evaluate for other cases
    return me.isB2BAllCatalog && (shouldRenderCategories || shouldRenderNewCourses || shouldRenderAcademies || shouldRenderMicroDegrees) || me.isB2BAdmin;
  };
  var shouldRenderCatalogMenu = getShouldRenderCatalogMenu();
  var shouldRenderCatalogAtEnd = shouldRenderCatalogMenu && Boolean(layoutConfig.renderCatalogAtEnd);
  var isEveryLeftDesktopActionVisible = shouldRenderCatalogMenu && shouldRenderResourcesButton && shouldRenderPremiumLandingLink && (shouldRenderB2BLandingLink || shouldRenderAdminDashboardLink);
  // Degrees dropdown button should be hidden on lg breakpoint for anonymous users
  // when every menu option is visible (there's not enough space)
  var shouldRenderDegreesButton = !layoutConfig.hideDegreesDropdown && !isBrazil && !me.isB2BOnlyPanel && !me.isB2BAllCatalog && (!me.isAnonymous || !(isEveryLeftDesktopActionVisible && shouldRenderShoppingCartLink)); // if all actions are visible

  var shouldRenderBlogCategories = !layoutConfig.hideBlogCategories;
  var shouldRenderDesktopBlogLeftMenu = !layoutConfig.hideDesktopBlogLeftMenu;
  var shouldRenderDownloadableResources = !layoutConfig.hideDownloadableResouces;
  var shouldRenderSocialLinks = !layoutConfig.hideSocialLinks;
  if (layoutConfig.hideEveryLeftMenuAction) {
    return null;
  }
  var leftMenuCommonProps = {
    shouldRenderCatalogMenu: shouldRenderCatalogMenu,
    shouldRenderSolutionsMenu: shouldRenderSolutionsMenu,
    shouldRenderCategories: shouldRenderCategories,
    shouldRenderNewCourses: shouldRenderNewCourses,
    shouldRenderAcademies: shouldRenderAcademies,
    shouldRenderMicroDegrees: shouldRenderMicroDegrees,
    shouldRenderResourcesButton: shouldRenderResourcesButton,
    shouldRenderDegreesButton: shouldRenderDegreesButton,
    shouldRenderAdminDashboardLink: shouldRenderAdminDashboardLink,
    shouldRenderPremiumLandingLink: shouldRenderPremiumLandingLink,
    shouldRenderB2BLandingLink: shouldRenderB2BLandingLink,
    shouldRenderCatalogAtEnd: shouldRenderCatalogAtEnd,
    shouldRenderBlogCategories: shouldRenderBlogCategories,
    shouldRenderDownloadableResources: shouldRenderDownloadableResources,
    shouldRenderSocialLinks: shouldRenderSocialLinks,
    shouldRenderDesktopBlogLeftMenu: shouldRenderDesktopBlogLeftMenu,
    shouldRenderHigherEdLink: shouldRenderHigherEdLink,
    onLeftMenuOpen: onLeftMenuOpen
  };
  if (variant !== 'light' && isSm) {
    return /*#__PURE__*/_jsx(LeftMenuDesktop, _objectSpread({
      className: "flex"
    }, leftMenuCommonProps));
  }
  return /*#__PURE__*/_jsx(LeftMenuMobile, _objectSpread(_objectSpread({}, leftMenuCommonProps), {}, {
    shouldRenderInboxLink: shouldRenderInboxLink,
    shouldRenderShoppingCartLink: shouldRenderShoppingCartLink,
    shouldHelpCenterLink: shouldHelpCenterLink,
    shouldRenderRegisterButton: shouldRenderRegisterButton,
    shouldRenderLoginButton: shouldRenderLoginButton,
    shouldRenderAppLinks: shouldRenderAppLinks
  }));
};
export default LeftMenu;